<template>
  <v-container fluid style="max-width: 1280px;">

    <v-row no-gutters class="mb-2">
      <v-col cols="12">
        <im-title-bar :title="hotel.name"/>
      </v-col>
    </v-row>

    <v-row no-gutters class="ma-0 pa-0">
      <v-col cols="12" md="8" order="2" order-md="1">
        <v-card outlined class="ma-2">
          <v-card-title>
            Date de contact
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid_user" ref="user_form">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field outlined v-model="user.name" label="Nume *" :rules="rules.user.name" placeholder="Jon Snow"/>
                </v-col>
                <v-col cols="6">
                  <v-text-field outlined v-model="user.email" label="Email *" :rules="rules.user.email" placeholder="jon.snow@email.com" class="mr-1"/>
                </v-col>
                <v-col cols="6">
                  <v-text-field outlined v-model="user.phone" label="Telefon" placeholder="(+40)75 555 555" class="ml-1"/>
                </v-col>
                <v-col cols="12">
                  <v-textarea outlined v-model="user.observations" label="Observatii"/>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <v-card outlined class="ma-2">
          <v-card-title>
            Date de facturare
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid_card" ref="card_form">
              <v-row no-gutters justify="end">
                <v-col cols="12">
                  <v-alert type="info">
                    Datele cardului vor fii folosite doar in cazul neprezentarii la hotel la data de check-in.
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-text-field outlined v-model="card.number" name="number" label="Card Number" :rules="rules.card.number" placeholder="4242 4242 4242 4242" v-mask="['#### #### #### ####']" class="mr-2"/>
                    <img :src="getCardImage(card.number)" height="56"/>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-text-field outlined v-model="card.name" name="name" label="Name" :rules="rules.card.name" placeholder="Jon Snow"/>
                </v-col>
                <v-col cols="6">
                  <v-text-field outlined v-model="card.expiry" name="expiry" label="Expiry" :rules="rules.card.expiry" placeholder="MM / YY" v-mask="['## / ##']" class="mr-1"/>
                </v-col>
                <v-col cols="6">
                  <v-text-field outlined v-model="card.cvc" name="cvc" label="CVC" :rules="rules.card.cvc" placeholder="123" v-mask="['###']" class="ml-1"/>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <v-card outlined class="ma-2">
          <v-card-title class="headline">
            Termeni
          </v-card-title>
          <v-card-text v-html="hotel.terms.ro.replace(/(?:\r\n|\r|\n)/g, '<br/>')"/>
        </v-card>
        <v-card outlined class="ma-2">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="8" sm="9" md="10">
                <div class="title">Preț total</div>
                <div class="headline">
                  <im-price :font-size="24" :price="getPriceTotal()" :currency="getPriceCurrency()"/>
                </div>
              </v-col>
              <v-col cols="4" sm="3" md="2">
                <v-btn
                  class="primary"
                  style="height: 64px;"
                  @click="book()"
                  block
                  depressed
                  :loading="loading"
                  :disabled="!valid_user || !valid_card">
                  Confirmă
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" order="1" order-md="2">
        <v-card outlined class="ma-2">
          <v-card-title class="headline">
            Sumar
          </v-card-title>
          <v-card-text>

            <v-row no-gutters>
              <v-col cols="12">
            <span class="subtitle-1">
              Rezervare pentru {{getIntervalInDays(availability.check_in, availability.check_out)}} nopti.
            </span>
              </v-col>
              <v-col cols="4" class="font-weight-bold">
                Check-In:
              </v-col>
              <v-col cols="8" class="text-right subtitle-2">
                {{ availability.check_in }}
              </v-col>
              <v-col cols="4" class="font-weight-bold">
                Check-Out:
              </v-col>
              <v-col cols="8" class="text-right subtitle-2">
                {{ availability.check_out }}
              </v-col>
            </v-row>

            <v-divider class="my-3"/>

            <v-row no-gutters>
              <v-col cols="12">
                <span class="subtitle-1">Inventar</span>
                <div v-for="(room, room_index) in availability.rooms" :key="'reservation_room_' + room_index">
                  <div v-for="(rate, rate_index) in room.prices" :key="'reservation_rate_' + rate_index">
                    <v-row v-if="rate.quantity && rate.quantity > 0" no-gutters align="center">

                      <v-col cols="9" class="text-left text-truncate font-weight-bold">
                        {{rate.quantity}}<small>x</small> {{room.name}}
                      </v-col>

                      <v-col cols="3" class="text-right text-truncate">
                        <im-price
                          :price="rate.price * rate.quantity"
                          :currency="rate.currency"
                          :font-size="14"
                        />
                      </v-col>

                      <v-col cols="12" class="mt-n2 text-left text-truncate text-capitalize caption">
                        {{rate.name}}
                      </v-col>

                    </v-row>
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-divider class="my-3"/>

            <v-row no-gutters align="center">
              <v-col cols="6">
                <div class="title text-left">Total</div>
              </v-col>
              <v-col>
                <div class="text-right">
                  <im-price :font-size="20" :price="getPriceTotal()" :currency="getPriceCurrency()"/>
                </div>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>

  import logger from "../logger";

  import IMTitleBar from '../components/items/TitleBar.vue';
  import IMPrice from "../components/utils/IMPrice";

  import Payment from 'payment';
  import visa from 'payment-icons/min/mono/visa.svg';
  import mastercard from 'payment-icons/min/mono/mastercard.svg';
  import maestro from 'payment-icons/min/mono/maestro.svg';
  import default_card from 'payment-icons/min/mono/default.svg';

  export default {

    components: {
      'im-title-bar': IMTitleBar,
      'im-price': IMPrice,
    },

    data: () => ({

      hotel: JSON.parse(sessionStorage.getItem('hotel')),
      availability: JSON.parse(sessionStorage.getItem('availability')),

      visa: visa,
      mastercard: mastercard,
      maestro: maestro,
      default_card: default_card,

      // user: {
      //   name: 'Jon Snow',
      //   email: 'jon.snow@email.com',
      //   phone: '(+40)75 555 555',
      //   address: 'Piata Charles de Gaulle, 15',
      //   country: 'Romania',
      //   city: 'Bucuresti',
      //   observations: 'Observatii'
      // },
      //
      // card: {
      //   number: '4242424242424242',
      //   name: 'Jon Snow',
      //   expiry: '12 / 20',
      //   cvc: '123'
      // },

      user: {
        name: null,
        email: null,
        phone: null,
        address: null,
        country: null,
        city: null,
        observations: null
      },

      card: {
        number: '',
        name: '',
        expiry: '',
        cvc: ''
      },

      loading: false,

      valid_user: false,
      valid_card: false,

      rules: {
        user: {
          name: [
            v => !!v || 'Name is required.',
          ],
          email: [
            v => !!v || 'Email is required.',
            v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email is invalid.'
          ]
        },
        card: {
          number: [
            v => !!v || 'Number is required.',
            v => Payment.fns.validateCardNumber(v) || 'Number is invalid.'
          ],
          name: [
            v => !!v || 'Name is required.',
          ],
          expiry: [
            v => !!v || 'Expiry date is required.',
            v => Payment.fns.validateCardExpiry(v.substring(0, 2), v.substring(5, 7)) || 'Expiry date is invalid.'
          ],
          cvc: [
            v => !!v || 'CVC is required.',
            v => Payment.fns.validateCardCVC(v) || 'CVC is invalid.'
          ]
        }
      },
    }),

    methods: {

      getIntervalInDays(check_in, check_out) {
        let date1 = this.$moment(check_in);
        let date2 = this.$moment(check_out);

        return date2.diff(date1, 'days');
      },

      getCardImage(number) {
        let type = Payment.fns.cardType(number);

        if (type === 'visa') return visa;
        if (type === 'mastercard') return mastercard;
        if (type === 'maestro') return maestro;

        return default_card;
      },

      getPriceTotal() {
        let total_price = 0;
        this.availability.rooms.forEach(room => {
          room.prices.forEach(rate => {
            if (rate.quantity > 0) {
              total_price += rate.price * rate.quantity;
            }
          });
        });

        return total_price;
      },

      getPriceCurrency() {
        return this.availability.currency;
      },

      getRooms() {
        let booked_rooms = [];
        this.availability.rooms.forEach(room => {
          room.prices.forEach(rate => {
            if (rate.quantity > 0) {
              booked_rooms.push({
                id: room.id,
                rate_id: rate.id,
                quantity: rate.quantity,
                total_price: rate.price * rate.quantity,
                currency: rate.currency,
                services: []
              })
            }
          });
        });

        return booked_rooms;
      },

      book() {

        let url = process.env.VUE_APP_ENDPOINT_SERVICES_BOOKING;
        let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
        let endpoint = secure + url + "/api/reservations/book";

        let params = {
          hotel_id: this.hotel.id,
          channel: 'mementobookings',
          total_price: this.getPriceTotal(),
          currency: this.availability.currency,
          arrival_date: this.availability.check_in,
          departure_date: this.availability.check_out,
          guests: {
            adults: this.availability.adults,
            children_ages: this.availability.children,
          },
          customer: {
            name: this.user.name,
            email: this.user.email,
            phone: this.user.phone,
            country: this.user.country,
            city: this.user.city,
            address: this.user.address,
            observations: this.user.observations
          },
          payment: {
            card_number: this.card.number.replace(/\s/g, ''),
            card_code: this.card.cvc,
            card_name: this.card.name,
            card_expiration_month: this.card.expiry.substring(0, 2),
            card_expiration_year: '20' + this.card.expiry.substring(5, 7)
          },
          rooms: this.getRooms()
        };

        this.loading = true;
        this.$axios.post(endpoint, params)
          .then((response) => {
            sessionStorage.setItem('reservation', JSON.stringify(response.data));
            sessionStorage.setItem('confirmed', 'true');
            this.$router.push('/confirmation');
          })
          .catch(error => {
            logger.error(error.message, error.stack).then(() => null);
            this.$router.push('/500')
          })
          .finally(() => {
            this.loading = false;
          })
      },
    }

  }
</script>